import { MantineProvider } from '@mantine/core'
import { PropsWithChildren, useEffect } from 'react'
import tinycolor from 'tinycolor2'
import { useTranslation } from 'react-i18next'

import { LemonadeProvider } from '@percent/lemonade'
import '@mantine/core/styles.css'
import '@mantine/dates/styles.css'
import { useEducationHostedForm } from '@percent/education-hosted-form/hooks/useEducationHostedForm/useEducationHostedForm'

const defaultColors = {
  ctaColor: '#000000',
  secondaryColor: '#EAEAFE'
}

// Exactly 10 elements required by Mantine
const fillColor = (color: string) => [color, color, color, color, color, color, color, color, color, color] as const

const getPrimaryAccent = (color: string) =>
  tinycolor(color).isDark() ? tinycolor(color).brighten(15).toString() : tinycolor(color).darken(15).toString()

export function ThemeProvider({ children }: PropsWithChildren) {
  const { t } = useTranslation()
  const { partnerConfig } = useEducationHostedForm()
  const partnerColor = partnerConfig?.configuration.primaryColor || defaultColors.secondaryColor

  useEffect(() => {
    if (partnerConfig) {
      const favicon = document.getElementById('favicon') as HTMLLinkElement
      const description = document.getElementById('description') as HTMLMetaElement

      if (favicon && document && description) {
        favicon.href = partnerConfig?.configuration.logo
        document.title = t('pageTitle', { partner: partnerConfig?.partner.name })
        description.content = t('contentApply', {
          partnerName: partnerConfig?.partner.name
        })
      }
    }
  }, [partnerConfig, t])

  return (
    <MantineProvider
      theme={{
        primaryColor: 'primary',
        colors: {
          // Hardcoding it for now to avoid adding additional dependencies, might add @mantine/colors-generator later if needed
          primary: fillColor(defaultColors.ctaColor),
          secondary: fillColor(partnerColor)
        }
      }}
    >
      <LemonadeProvider
        customPalette={{
          primary400: defaultColors.ctaColor,
          primary600: getPrimaryAccent(defaultColors.ctaColor)
        }}
      >
        {children}
      </LemonadeProvider>
    </MantineProvider>
  )
}
